////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, map } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const notifications = {
	[ActionsTypes.GET_LOGS_NOTIFICATION]: (state) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_LOGS_NOTIFICATION_SUCCESS]: (state, payload) => {
		let logs = payload.data
		return update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: logs,
				},
			},
		})
	},
	[ActionsTypes.GET_LOGS_NOTIFICATION_FAILURE]: (state, payload) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.UPDATE_RESOLVED_LOG]: (state) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.UPDATE_RESOLVED_LOG_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.notifications.items)
		let updateDatas = stateCp.filter((st) => st.id !== data.id)

		return update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: updateDatas,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_RESOLVED_LOG_FAILURE]: (state, payload) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.CLOSE_NOTIFICATION]: (state) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: true,
				},
			},
		}),

	[ActionsTypes.CLOSE_NOTIFICATION_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.notifications.items)
		let updateDatas = stateCp.filter((st) => st.id !== data.id)

		return update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: updateDatas,
				},
			},
		})
	},
	[ActionsTypes.CLOSE_NOTIFICATION_FAILURE]: (state, payload) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.CLOSE_ALL_NOTIFICATION]: (state) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.CLOSE_ALL_NOTIFICATION_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.notifications.items)
		const ids = map(data, 'id')
		let test = stateCp.filter((s) => !ids.includes(s.id))

		return update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: test,
				},
			},
		})
	},
	[ActionsTypes.CLOSE_ALL_NOTIFICATION_FAILURE]: (state, payload) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.REPORT_NOTIFICATION]: (state) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.REPORT_NOTIFICATION_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.notifications.items)
		let updateDatas = stateCp.filter((st) => st.id !== data.id)

		return update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: updateDatas,
				},
			},
		})
	},
	[ActionsTypes.REPORT_NOTIFICATION_FAILURE]: (state, payload) =>
		update(state, {
			notifications: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default notifications
